import { useCurrentUserContextCurrentUserLazyQuery } from '~/common/types/graphql'

export const useCurrentUserLazyQuery = () => {
  return useCurrentUserContextCurrentUserLazyQuery()
}
